import { useQuery } from '@apollo/client';

import useConfig from 'app/config';
import LEADS_ACCESS from 'app/features/leads/graphql/leads-access.gql';
import { canPerform } from 'app/features/leads/utils/can-perform-partner-permission';
import type { LeadsAccessQuery, LeadsAccessQueryVariables } from 'app/types/graphql';
import { useAppState } from 'state';

export const useLeadsAccess = () => {
  const { config } = useConfig();
  const enabled = config.REACT_APP_GYM_FINDER_LEADS_ENABLED;
  const userId = useAppState(({ auth }) => auth.userId);
  const hasUser = userId != null;

  const { data, loading } = useQuery<LeadsAccessQuery, LeadsAccessQueryVariables>(LEADS_ACCESS, {
    variables: hasUser ? { id: userId } : undefined,
    skip: !enabled || !hasUser,
    fetchPolicy: 'cache-first',
  });

  const permissions = data?.userById?.partnerPermissions ?? [];
  const currentPartnerId = data?.myPartners.currentPartnerId ?? null;
  const hasLeadsPermission = canPerform(permissions, 'Gym', 'update', currentPartnerId);

  return {
    canAccessLeads: enabled && hasUser && !loading && hasLeadsPermission,
    isLoading: enabled && hasUser && loading,
  };
};
